import { render } from "./SectionOfficialBusiness.vue?vue&type=template&id=7ee591bc&scoped=true"
import script from "./SectionOfficialBusiness.vue?vue&type=script&lang=js"
export * from "./SectionOfficialBusiness.vue?vue&type=script&lang=js"

import "./SectionOfficialBusiness.vue?vue&type=style&index=0&id=7ee591bc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee591bc"]])

export default __exports__